import Home from "./Home.jsx"
import About from "./About.jsx"
import Login from "./Login.jsx"
import Register from "./Register.jsx"
import Contact from "./Contact.jsx"
import TnC from "./TnC.jsx"
import HomePromt from "./HomePrompt.jsx"
import Processing from './Processing.jsx'
import SandBox from './SpeedRun/sandbox/index.jsx'
import PrivacyPolicy from "./PrivacyPolicy.jsx"
import ServiceIntegration from "./ServiceIntegration.jsx"
import LimitedUseDisclosure from "./Disclosure.jsx"
import { ResetPasswordPanel } from "../components/signin-panel/index.jsx"
import FAQ from "./Faq.jsx"
import { Pricing, Upgrade } from "./Pricing/Pricing.jsx"
import UsageLimits from "./UsageLimits.jsx"
// import WeatherWidget from "../components/weather-widget/WeatherWidget.jsx"

const routes = [
  { path: '/', component: <Home />},
  { path: '/nelima', component: <SandBox />},
  { path: '/service-integration', component: <ServiceIntegration/>},
  { path: '/about', component: <About />},
  { path: '/login', component: <Login />},
  { path: '/register', component: <Register />},
  { path: '/contact', component: <Contact />},
  { path: '/terms-n-conditions', component: <TnC />},
  { path: '/faq', component: <FAQ/>},
  { path: '/privacy', component: <PrivacyPolicy />},
  { path: '/limited-use-disclosure', component: <LimitedUseDisclosure />},
  { path: '/processing', component: <Processing />},
  { path: '/account/reset-password', component: <ResetPasswordPanel/>},
  { path: '/pricing', component: <Pricing/>},
  { path: '/upgrade', component: <Upgrade/>},
  { path: '/usage-limit', component: <UsageLimits/>},
  { path: '/:prompt', component: <HomePromt />}
]
  
export default routes